<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="12">
              <v-file-input
                class="fileInput"
                ref="fileInput"
                :accept="fileType"
                :multiple="multiple"
                @change="addFiles"
              ></v-file-input>
              <v-card
                ref="dragInput"
                @drop.prevent="onDrop($event)"
                @dragover.prevent="dragover = true"
                @dragenter.prevent="dragover = true"
                @dragleave.prevent="dragover = false"
                @click.prevent="clickUpload"
                :class="dragClass"
                :disabled="!canUpload"
              >
                <v-card-text>
                  <v-row
                    class="d-flex flex-column"
                    dense
                    align="center"
                    justify="center"
                  >
                    <v-icon
                      :class="[dragover ? 'mt-2, mb-6' : 'mt-5 ']"
                      color="primary"
                      size="60"
                    >
                      mdi-cloud-upload
                    </v-icon>
                    {{ uploadText }}
                  </v-row>
                  <v-virtual-scroll
                    v-if="isUpload"
                    :items="uploadedFiles"
                    item-height="60"
                  >
                    <template v-slot:default="{ item }">
                      <v-list-item :key="item.name">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.name }}
                            <span class="ml-3 text--secondary">
                              {{ fileSize(item.size) }}</span
                            >
                          </v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action v-if="!instant">
                          <v-btn @click.stop="removeFile(item.name)" icon>
                            <v-icon> mdi-close-circle </v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-virtual-scroll>
                  <div>
                    <v-progress-linear
                      :value="progress"
                      v-if="isUpload"
                      color="light-blue"
                      height="25"
                      disabled
                    >
                      <strong>{{ progress }} %</strong>
                    </v-progress-linear>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'

export default {
  name: 'TestUploadForm',
  components: {},
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      mainData: {},
      dragover: false,
      progress: 0,
      uploadedFiles: [],
      uploadValidated: true,
      fileType: '.pdf,.adoc,.asice',
      maxDydis: 20,
      multiple: true,
      canUpload: true,
      instant: false,
    }
  },
  computed: {
    getTitle() {
      return `title`
    },
    fileTypeList() {
      return this.fileType.replaceAll('.', '').split(',')
    },
    maxDydisByte() {
      return this.maxDydis * 1024 * 1024
    },
    dragClass() {
      return (this.dragover ? 'blue lighten-1' : '') + 'mb-2'
    },
    isUpload() {
      return this.uploadedFiles.length > 0
    },
    uploadText() {
      return 'Paspauskite arba įtempkite rinkmeną'
    },
  },
  beforeDestroy() {},
  created() {},
  methods: {
    clickUpload() {
      this.$refs.dragInput.$el.blur()
      this.$refs.fileInput.$refs.input.click()
    },
    addFiles(files) {
      this.dragover = false
      this.uploadedFiles = []
      files.forEach((element) => this.addUploadedFiles(element))
      if (this.instant) {
        this.saveData()
      }
    },
    addUploadedFiles(element) {
      let tipas = element.name.toLowerCase().split('.').pop()
      if (!this.fileTypeList.includes(tipas)) {
        this.$root.$emit(
          'DATA_ERROR',
          'Netinkamas dokumento formatas, galima įkelti tik PDF, ADOC ir ASICE'
        )
        return
      }
      if (element.size > this.maxDydisByte) {
        this.$root.$emit(
          'DATA_ERROR',
          `Leistinas dokumento dydis: ${this.maxDydis} MB`
        )
        return
      }
      this.uploadedFiles.push(element)
    },
    validateUpload() {
      this.uploadValidated = this.isUpload || !this.uploadRequired
    },
    updateProgress(progress) {
      this.progress = progress
    },
    fileSize(size) {
      if (size < 1024) {
        return size + ' B'
      } else if (size < 1024 * 1024) {
        return Math.round(size / 1024) + ' KB'
      } else if (size < 1024 * 1024 * 1024) {
        return Math.round(size / (1024 * 1024)) + ' MB'
      }
    },
    removeFile(fileName) {
      const index = this.uploadedFiles.findIndex(
        (file) => file.name === fileName
      )
      if (index > -1) this.uploadedFiles.splice(index, 1)
    },
    saveData() {
      this.validateUpload()
      this.$validator.validateAll().then((res) => {
        if (res && this.uploadValidated) {
          this.loading = true
          const byla = this.uploadedFiles[0]
          let formData = new FormData()

          if (this.isUpload) {
            formData.append('byla', byla)
          }
          const config = {
            onUploadProgress: (progressEvent) => {
              this.progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              )
            },
          }

          this.$axios
            .post(`upload/test`, formData, config)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.$emit('savedData')
              this.closeModal()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
              this.progress = 0
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
